import { Accordion } from '../../../../../components/general/accordion';
import TodayIcon from '@mui/icons-material/Today';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrInfoProps } from './props';
import { usePqrInfo } from './hook';

export const PqrInfo = ({ info }: PqrInfoProps) => {
    const { formik } = usePqrInfo(info);

    return (
        <Accordion
            title="INFORMACIÓN PQR"
            icon={<TodayIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Estado"
                        name="status"
                        size="small"
                        value={formik.values.status}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="País"
                        name="country"
                        size="small"
                        value={formik.values.country}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Ubicación PQR"
                        name="location"
                        size="small"
                        value={formik.values.location}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Radicado de correspondencia"
                        name="correspondenceFiling"
                        size="small"
                        value={formik.values.correspondenceFiling}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FieldText
                        label="Detalle de PQR"
                        name="detail"
                        size="small"
                        rows={3}
                        value={formik.values.detail}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
